export const general = [0, 4, 8, 12, 16, 24, 32, 48, 64, 128, 256]
